/* tslint:disable */
/* eslint-disable */
/**
 * Sunshine Auction API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AdminWorkerRunResp
 */
export interface AdminWorkerRunResp {
    /**
     * Queued is false when the same job is already queued or running.
     * @type {boolean}
     * @memberof AdminWorkerRunResp
     */
    queued: boolean;
}

export function AdminWorkerRunRespFromJSON(json: any): AdminWorkerRunResp {
    return AdminWorkerRunRespFromJSONTyped(json, false);
}

export function AdminWorkerRunRespFromJSONTyped(json: any, ignoreDiscriminator: boolean): AdminWorkerRunResp {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'queued': json['queued'],
    };
}

export function AdminWorkerRunRespToJSON(value?: AdminWorkerRunResp | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'queued': value.queued,
    };
}

